function generateTableOfContents() {
  let tocArray = [];
  let level = 1;
  let toc = "";

  const content = document.querySelector(".article-content__content");
  const headers = content.querySelectorAll('h1, h2, h3, h4, h5, h6');
  for (let header of headers) {
    const anchor = document.createElement('div');
    anchor.id = Array.from(headers).indexOf(header);
    content.insertBefore(anchor, header);
    tocArray.push({ 'text': header.innerHTML, 'level': parseInt(header.tagName.split('H')[1]), 'index': parseInt(anchor.id) });
  }

  for (let tocItem of tocArray) {
    if (tocItem.level > level) {
      toc += (new Array(tocItem.level - level + 1)).join("<ul>");
    } else if (tocItem.level < level) {
      toc += (new Array(level - tocItem.level + 1)).join("</ul>");
    }
    level = tocItem.level;
    let text = tocItem.text.trim().replace(/(<br>)|(<br \/>)|(<br\/>)|(&nbsp;)|[[:space:]]|[[:cntrl:]]|[^[:print:]]/ig,'');
    if(text.length > 0)
      toc += `<li><a href="#${tocItem.index}">${text}</a></li>`;
  }
  document.getElementById("toc").innerHTML = toc;
  if (toc.length > 0) {
    document.querySelector("#table_of_contents").classList.remove('d-none')
  }
};

generateTableOfContents();
